/* 三個候選風格共用的小工具。放這裡是為了讓每個風格檔只剩「配方」，
   讀的人一眼就能比較三種語言的差別。 */

export function rnd(a: number, b: number) { return a + Math.random() * (b - a); }

/** 躺平 quad 的 yaw：quad 的局部 +X 要對準 (sin a, 0, cos a)。
    推導見 `vfx-pool.ts` 的 YXZ 註解。 */
export function yawOf(ang: number) { return ang - Math.PI / 2; }

/** 躺平（面朝天）的 pitch。 */
export var FLAT = -Math.PI / 2;
